import React, { useEffect, useState } from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import "../../Styles/HomeComponentsStyles/HeroSection.css";
import { useNavigate } from "react-router-dom";

const HeroSection = ({ theme }) => {
  const navigate = useNavigate();
  return (
    <div className={`hero__section ${theme}`}>
      <div className="upper__bar">
        <div className="button">
          <span className="text">SUBSCRIBE</span>
        </div>
        <div className="row">
          <span className="text">Start Your 14 Days Free Trial </span>
          <span className="icon">
            <KeyboardArrowRightIcon />
          </span>
        </div>
      </div>
      <div className="main__heading">
        Visualize <span className="blue__text">Financial</span> &{" "}
        <span className="yellow__text">Business</span>{" "}
        <span className="green__text">Metrics</span>
      </div>
      <div className="sub__heading">
        Revenue, Gross Profit, Operating Income, Net Income, Margins, and more
        to make better investmnt decions.
      </div>
      <div className="cto__btn">
        <span className="text" onClick={() => navigate("/All-Stocks")}>
          Get Started
        </span>
      </div>
    </div>
  );
};

export default HeroSection;
